// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__p1vmZ"};